import intl from '../../services/intl-service';
import Joi from 'joi-browser';

export const upravljanjeTerminalimaSchema = {
   brojTerminala: Joi.number()
      .integer()
      .min(1)
      .max(9999)
      .required()
      .label(intl.getTranslate('terminal.broj'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'terminal.brojTerminalaValidator'
            )}`
         };
      })
};
